// extracted by mini-css-extract-plugin
export default {"description":"mrnHO9","descriptionLoader":"HZCf1a","moreLessButton":"En8omo","descriptionText":"_cwDpU"};